import React from 'react'

const Manual_inventario_mermas = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
      <div className="mt-16">
        <h2 className="font-bold xl-text-[40px] lg:text-4xl md:text-4xl text-4xl text-[#002D33] mb-5">
          Inventario - Mermas
        </h2>
        <p className="text-lg text-gray-700 mb-6">
          Esta guía detalla un método paso a paso para gestionar eficazmente el desperdicio de inventario, conocido como "Mermas". Ayuda a los usuarios a registrar información crucial, seleccionar productos adecuados y monitorear su estado, asegurando precisión en los ajustes de inventario. Siguiendo estos pasos, podrás mejorar la gestión de mermas, reducir errores y mantener un control óptimo del inventario.
        </p>
        <iframe
          src="https://scribehow.com/embed/Inventario__Mermas__KPM9y-9SQxmCkdRaAsghaA?as=scrollable"
          className="scribe-iframe-general-37"
          width="100%"
          height="8150"
          allowFullScreen
          style={{ border: 0, minHeight: '640px' }}
        ></iframe>
      </div>
    </div>
  )
}

export default Manual_inventario_mermas